__turbopack_context__.v({
  "active": "Navbar-module-scss-module__XwEV4q__active",
  "buttonsWrapper": "Navbar-module-scss-module__XwEV4q__buttonsWrapper",
  "close": "Navbar-module-scss-module__XwEV4q__close",
  "collapsedSubmenu": "Navbar-module-scss-module__XwEV4q__collapsedSubmenu",
  "container": "Navbar-module-scss-module__XwEV4q__container",
  "expandBtn": "Navbar-module-scss-module__XwEV4q__expandBtn",
  "expandedSubmenu": "Navbar-module-scss-module__XwEV4q__expandedSubmenu",
  "hide": "Navbar-module-scss-module__XwEV4q__hide",
  "icon": "Navbar-module-scss-module__XwEV4q__icon",
  "logoWrapper": "Navbar-module-scss-module__XwEV4q__logoWrapper",
  "logoWrapperImage": "Navbar-module-scss-module__XwEV4q__logoWrapperImage",
  "navbar": "Navbar-module-scss-module__XwEV4q__navbar",
  "navbarExpanded": "Navbar-module-scss-module__XwEV4q__navbarExpanded",
  "slideIn": "Navbar-module-scss-module__XwEV4q__slideIn",
  "slideUp": "Navbar-module-scss-module__XwEV4q__slideUp",
  "submenu": "Navbar-module-scss-module__XwEV4q__submenu",
});
